import { History, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useDashboardChat } from "@/hooks/useDashboardChat";

export function DashboardHeaderActions() {
  const chat = useDashboardChat();
  if (!chat) return null;

  return (
    <div className="flex items-center gap-2">
      {chat.messages.length > 0 && (
        <Button variant="default" size="icon" className="h-9 w-9" onClick={chat.handleNewChat}>
          <Plus size={18} />
        </Button>
      )}
      <Button
        variant="outline"
        size="icon"
        className="h-9 w-9"
        onClick={() => chat.setHistoryOpen(true)}
      >
        <History size={18} />
      </Button>
    </div>
  );
}
